"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var storybook_1 = require("@eyecons/storybook");
var prop_types_1 = __importDefault(require("prop-types"));
var ra_fetch_1 = require("ra-fetch");
function checkLimit(id, channel, livestream, user) {
    // TODO return limit
    return false;
    if (id || user.is_admin) {
        return false;
    }
    if (livestream.data.type === 'rtmp' && channel.livestreams_rtmp_limit_reached) {
        return true;
    }
    return livestream.data.type === 'hls' && channel.livestreams_hls_limit_reached;
}
function Create(_a) {
    var user = _a.user, channel = _a.channel, id = _a.id;
    var _b = ra_fetch_1.useApi('backend').store('livestreams', {
        channel_id: channel.id,
        channel_type: channel.type,
        type: '',
        auto: true,
        publish: true,
        pullzone_id: '',
        source_path: '',
    }), livestream = _b[0], setLivestream = _b[1], saveLivestream = _b[2];
    if (checkLimit(id, channel, livestream, user)) {
        return react_1.default.createElement(storybook_1.Livestreams.FormLimit, { type: livestream.data.type });
    }
    return react_1.default.createElement(storybook_1.Livestreams.Create, { livestream: livestream, setLivestream: setLivestream, saveLivestream: saveLivestream });
}
exports.default = Create;
Create.propTypes = {
    /**
     * Current user session
     */
    user: prop_types_1.default.shape({
        id: prop_types_1.default.number.isRequired,
    }).isRequired,
    /**
     * Current channel
     */
    channel: prop_types_1.default.shape({
        id: prop_types_1.default.number.isRequired,
    }).isRequired,
};
